import { render, staticRenderFns } from "./BaseEditPageTextField.vue?vue&type=template&id=7532a0b2"
import script from "./BaseEditPageTextField.vue?vue&type=script&lang=js"
export * from "./BaseEditPageTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports